<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('userIntegral.queryCondition') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="userIntegralInfo.conditions.integralName"
            :placeholder="$t('userIntegral.selectAccountName')" clearable />
        </el-col>
        <el-col :span="2">
          <el-button type="primary" size="small" @click="_queryIntegralMethod">
            <i class="el-icon-search"></i>
            {{ $t('userIntegral.query') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('userIntegral.userIntegral') }}</span>
      </div>
      <el-table :data="userIntegralInfo.integrals" border style="width: 100%">
        <el-table-column prop="integralId" :label="$t('userIntegral.number')" align="center" />
        <el-table-column prop="integralName" :label="$t('userIntegral.accountName')" align="center" />
        <el-table-column :label="$t('userIntegral.objectType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.objType === '7007' ? $t('userIntegral.merchant') : $t('userIntegral.user') }}
          </template>
        </el-table-column>
        <el-table-column prop="objId" :label="$t('userIntegral.userNumber')" align="center" />
        <el-table-column prop="link" :label="$t('userIntegral.phoneNumber')" align="center" />
        <el-table-column prop="amount" :label="$t('userIntegral.integralCount')" align="center" />
        <el-table-column :label="$t('userIntegral.operation')" align="center" width="250">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="_changeIntegralAmount(scope.row, '1001')">
                {{ $t('userIntegral.give') }}
              </el-button>
              <el-button size="mini" v-if="scope.row.amount > 0" @click="_changeIntegralAmount(scope.row, '2002')">
                {{ $t('userIntegral.deduct') }}
              </el-button>
              <el-button size="mini" @click="_openDeleteIntegralModel(scope.row)">
                {{ $t('userIntegral.delete') }}
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="userIntegralInfo.total" />
    </el-card>

    <edit-integral ref="editIntegral" @refresh="queryIntegral" />
    <delete-integral ref="deleteIntegral" @refresh="queryIntegral" />
  </div>
</template>

<script>
import { listIntegral } from '@/api/admin/integralApi'
import EditIntegral from '@/components/admin/editIntegral/editIntegral'
import DeleteIntegral from '@/components/admin/deleteIntegral/deleteIntegral'

export default {
  name: 'UserIntegral',
  components: {
    EditIntegral,
    DeleteIntegral
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      userIntegralInfo: {
        integrals: [],
        total: 0,
        conditions: {
          integralName: '',
          objType: '6006',
          objId: '',
          amount: ''
        }
      }
    }
  },
  created() {
    this._listIntegrals(1, 10)
  },
  methods: {
    handleCurrentChange(val) {
      this._listIntegrals(val, this.pageSize)
    },
    queryIntegral() {
      this._listIntegrals(1, 10)
    },
    async _listIntegrals(page, row) {
      try {
        const params = {
          ...this.userIntegralInfo.conditions,
          page,
          row
        }
        const res = await listIntegral(params)
        this.userIntegralInfo.integrals = res.data
        this.userIntegralInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _queryIntegralMethod() {
      this._listIntegrals(1, this.pageSize)
    },
    _openDeleteIntegralModel(integral) {
      this.$refs.deleteIntegral.open(integral)
    },
    _changeIntegralAmount(integral, detailType) {
      this.$refs.editIntegral.open({
        detailType,
        integralName: integral.integralName,
        integralId: integral.integralId,
        amount: integral.amount,
        link: integral.link
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>